import { useMemo, useEffect, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import createBoardPermissionSelector from './createBoardPermissionSelector'
import viewError from 'store/sagas/viewError'
import { useBoardProvider } from 'components/KanBoProvider/KanBoProvider'

type StateProps = {
  permission: any;
  isLoaded?: boolean;
  isClosed?: boolean;
}

const useBoardDataProvider = ({
  id,
}: {
  id?: number
}) => {  
  const intl = useIntl()

  const selector = useMemo(() => createStructuredSelector<any, StateProps>({
    permission: createBoardPermissionSelector(id),
    isLoaded: state => id && state['view-board'].view[id]?.isLoaded,
    isClosed: state => id && state['view-board'].view[id]?.isClosed,
  }), [id])

  const {
    permission,
    isLoaded,
    isClosed,
  } = useSelector(selector)

  const dispatch = useDispatch()

  const showViewError = useCallback(
    (arg) => dispatch(viewError(arg)),
    [dispatch]
  )

  const boardIds = useMemo(() => id ? [id] : [], [id])

  useBoardProvider(boardIds)

  useEffect(() => {
    if (id && isLoaded) {
      if (!permission.reader) {
        showViewError({
          text: intl.formatMessage({ id: 'BOARD_ACCESS_DENIED' })
        })
      }
    }
  }, [id, isLoaded, permission])

  return {
    isLoaded,
    isReady: id ? Boolean(isLoaded && permission.reader && !isClosed) : false,
    isClosed,
  }
}

export default useBoardDataProvider